import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Dispatch } from 'redux';
import DefaultRedirect from '../../routing/DefaultRedirect';
import { logout } from '../../stores/auth/actionCreators';
import { isLoggedIn } from '../../stores/auth/selectors';
import { RootState } from '../../stores/store';
import LoadingScreen from '../navigation/LoadingScreen';

export interface Props extends RouteComponentProps, LocalizeContextProps {
    isLoggedIn: boolean;

    logout: () => void;
}

export class LogoutPage extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    public componentDidMount() {
        this.props.logout();
    }

    public render() {
        const t = this.props.translate;
        if (this.props.isLoggedIn) {
            return <LoadingScreen text={t('logout.loading.loggingOut') as string} />;
        } else {
            return <DefaultRedirect />;
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    isLoading: isLoggedIn(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(LogoutPage)));
